import React, { useState, useEffect } from 'react'
import { Button, Col, Divider, Drawer, Row, Typography, message, Table, InputNumber } from 'antd'
import UISpinner from '../../../../components/UISpinner'
import inventorySrc from '../../inventorySrc'

const { Title } = Typography

function OrderDrawer(props) {
    const [dataTable, setDataTable] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [order, setOrder] = useState([])
    const [loading, setLoading] = useState(false)

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => {
            setSelectedRowKeys(selectedKeys);
            // Filtrar los objetos seleccionados y mostrarlos en la consola
            const selectedRows = dataTable.filter(row => selectedKeys.includes(row.key));
            console.log('Filas seleccionadas:', selectedRows);
        },
    };

    useEffect(() => {
        if (Object.keys(props.viewOrder).length > 0) {
            setDataTable(setProducts(props.viewOrder))
            setOrder(props.viewOrder.data.data[0].order)
        }
    }, [props.viewOrder])

    const columns = [
        {
            title: 'Producto',
            dataIndex: 'presentation', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
        {
            title: 'Cantidad',
            dataIndex: 'quantity', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
        {
            title: 'Recibir',
            dataIndex: 'quantity_received',
            render: (text, record) => (
                <InputNumber
                    min={1}
                    value={record.quantity_received}
                    onChange={(value) => handleQuantityChange(value, record.key)}
                />
            ),
        },
        {
            title: 'Unidad de medida',
            dataIndex: 'uom', // Field that is goint to be rendered
            render: text => <span>{text}</span>,
        },
    ]

    // Función para actualizar la cantidad en la tabla
    const handleQuantityChange = (value, key) => {
        setDataTable(prevData =>
            prevData.map(item =>
                item.key === key ? { ...item, quantity_received: value } : item
            )
        );
    };

    const setProducts = products => {
        if (products !== 'Too Many Attempts.') {
            let _products = products.data.data || []

            return _products.map((d, i) => ({
                key: i,
                id: d.id,
                presentation: d.presentation,
                presentation_id: d.presentation_id,
                uom: d.uom,
                uom_id: d.uom_id,
                quantity: d.quantity,
                quantity_received: d.quantity_received,
                unit_cost: d.unit_cost,
            }))
        } else {
            message.error('Se excedió el limite de peticiones, espera y recarga la aplicación')
        }
    }

    const save = () => {
        const presentations = dataTable.map(item => ({
            id: item.presentation_id,
            quantity: item.quantity_received,
            unit_price: item.unit_cost,
            uom_id: item.uom_id
        }))

        const data = {
            provider_id: order.provider_id,
            store_id: order.store_dest_id,
            invoice: order.invoice,
            serial_number: order.serie,
            payment_method_id: order.payment_method_id,
            presentations
        }

        props.setFetchData(false)
        setLoading(true)
        inventorySrc
            .savePurchase(data)
            .then(res => {
                if (res.errors && Object.keys(res.errors)?.length > 0) {
                    checkErrors(res)
                    setLoading(false)
                } else {
                    updateDetails(presentations)
                    onChangeStatus(8)
                    onCancel()
                    setLoading(false)
                    message.success('Compra creada.')
                    props.setFetchData(true)
                }
            })
            .catch(err => {
                console.log(err)
                message.error('Error al guardar la compra')
                setLoading(false)
            })
    }

    const updateDetails = (data) => {
        inventorySrc
            .updateProducts(order.id, { products: data })
            .then(res => {
                message.success('Orden Actualizada.')
            })
            .catch(err => {
                console.log(err)
                message.error('Error al actualizar la orden')
            })
    }

    const onChangeStatus = (status) => {
        setLoading(true)
        props.setFetchData(false)

        inventorySrc
            .updateOrder(order.id, { status })
            .then(order => {
                onCancel()
                setLoading(false)
                props.setFetchData(true)
            })
            .catch(err => {
                console.log(err)
                message.error('No se ha podido cargar la orden.')
                setLoading(false)
            })
    }

    const checkErrors = res => {
        let showDuplicateError = true

        const errors = Object.keys(res.errors).reduce((r, k) => {
            if (res.errors[k][0].indexOf('presentations') > -1 && res.errors[k][0].indexOf('duplicado') > -1) {
                showDuplicateError && message.error('No se admiten productos duplicados.')
                showDuplicateError = false
                return r
            } else {
                return Object.assign(r, { [k]: res.errors[k] })
            }
        }, {})

        Object.keys(errors).map(key => {
            switch (key) {
                case 'invoice':
                    message.error(errors[key][0].replace('invoice', 'No. Factura'))
                    break
                case 'serial_number':
                    message.error(errors[key][0].replace('serial_number', 'No. Serie'))
                    break
                default:
                    message.error(errors[key])
                    break
            }
            return null
        })
    }

    const onCancel = () => {
        props.closable(false)
    }

    return (
        <Drawer placement="right" closable={false} onClose={onCancel} visible={props.visible} width={800}>
            {props.loading && (
                <div className="loading-spinner">
                    <UISpinner />
                </div>
            )}
            <div>
                <Title> Productos </Title>
                <Divider className={'divider-custom-margins-users'} />
                <Row gutter={16} className={'section-space-list'}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <Table
                            className={'CustomTableClass'}
                            dataSource={dataTable}
                            columns={columns}
                            pagination={false}
                            loading={props.loading}
                            rowKey={(record, index) => index}
                        />
                    </Col>
                </Row>
            </div>

            <div>
                <Divider className={'divider-custom-margins-users'} />
                <Row gutter={16}>
                    <Col xs={24} sm={24} md={24} lg={24}>
                        <div className="text-right">
                            <div>
                                <Button loading={loading} type={'link'} className="cancel-button" onClick={() => onCancel()}>
                                    Salir
                                </Button>
                                <Button disabled={order.status_id != 6} loading={loading} className="title-tendero new-button no-ajustar-btn product-margin-header-button" onClick={() => onChangeStatus(9)}>
                                    Rechazar
                                </Button>
                                <Button disabled={order.status_id != 6} loading={loading} className="title-tendero new-button" onClick={() => save()}>
                                    Recibir
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Drawer>
    )
}

export default OrderDrawer